import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var trainingListRes;
export const trainingListTodo = createAsyncThunk('trainingList', async (date) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'course/view_training_list',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return trainingListRes = res.data
    } catch (error) {
        return trainingListRes = error.response.data
    }
})


const trainingListSlice = createSlice({
    name: 'trainingList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(trainingListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('trainingList', state.data)
            }
        });
        builder.addCase(trainingListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default trainingListSlice.reducer; 